import script from "./ListarLotesCobrancas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarLotesCobrancas.vue?vue&type=script&setup=true&lang=js"

import "./ListarLotesCobrancas.vue?vue&type=style&index=0&id=32c2e0e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c2e0e0"]])

export default __exports__